export default __webpack_public_path__ + "static/media/broken-heart@3x.a52debea.png";